/**
 * An equivalent copy of this file exists in billing-ui, ficon-ui and
 * lightning-ui. Unless a change is app-specific, apply it there too.
 */
import type { AxiosRequestConfig } from 'axios';

import { HttpHeader } from '@rygen/rygen-ui/model';

import { version } from '@/version';

export default (config: AxiosRequestConfig): AxiosRequestConfig => {
  if (version && config.headers) {
    config.headers[HttpHeader.APPLICATION_VERSION] = version;
  }

  return config;
};
